import React from 'react';
import { ConfigService } from '../../services';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const companyName = ConfigService.appName();
  const version = ConfigService.appVersion();

  return (
    <div className="text-center my-3 absolute left-0 bottom-0 right-0 w-full block px-10">
      <p className="flex justify-center">
        <span className="w-full">
          Copyright &copy; {currentYear} {companyName}. All Rights Reserved
        </span>
        <span className="ml-auto">{version && `${version}`}</span>
      </p>
    </div>
  );
};

export default Footer;
